import { memo } from "react";

const AppArticleCategoryIcon = ({ color = "#3069B2" }) => {
	return (
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_8450_11319)">
				<path
					d="M16 5.58999V3.07999C16 1.37999 14.68 -9.76585e-06 13.05 -0.0100098H5.55C5.41 -0.0100098 5.28 0.00999023 5.14 0.0299902C3.81 0.22999 2.77 1.33999 2.63 2.74999C2.74 2.73999 2.84 2.71999 2.95 2.71999H3.82C3.95 2.01999 4.46 1.46999 5.11 1.28999C5.25 1.24999 5.39 1.22999 5.55 1.22999H13.05C14.02 1.22999 14.81 2.05999 14.81 3.07999V14.18C14.81 14.29 14.8 14.41 14.78 14.52C14.65 15.26 14.1 15.85 13.4 15.99V5.81999C13.4 4.11999 12.08 2.73999 10.45 2.72999H2.95C1.32 2.72999 0 4.10999 0 5.81999V16.92C0 18.6 1.29 19.96 2.89 20C2.91 20 2.93 20 2.95 20H10.45C12.08 20 13.4 18.62 13.4 16.91C13.4 17.02 13.38 17.12 13.37 17.23C14.75 17.07 15.84 15.92 15.97 14.47C15.97 14.37 16 14.28 16 14.18V9.79999H15.98V5.58999H16ZM12.21 16.91C12.21 17.93 11.42 18.76 10.45 18.76H2.95C1.98 18.76 1.19 17.93 1.19 16.91V5.81999C1.19 4.79999 1.98 3.96999 2.95 3.96999H10.45C10.57 3.96999 10.69 3.97999 10.81 4.00999C11.61 4.17999 12.22 4.92999 12.22 5.81999V16.92L12.21 16.91Z"
					fill={color}
				/>
				<path d="M9.81998 5.81H3.56998C3.23998 5.81 2.97998 6.09 2.97998 6.43C2.97998 6.77 3.24998 7.05 3.56998 7.05H9.81998C10.15 7.05 10.41 6.77 10.41 6.43C10.41 6.09 10.14 5.81 9.81998 5.81Z" fill={color} />
				<path
					d="M9.82016 9.09998H8.50016C8.17016 9.09998 7.91016 9.37998 7.91016 9.71998C7.91016 10.06 8.18016 10.34 8.50016 10.34H9.82016C10.1502 10.34 10.4102 10.06 10.4102 9.71998C10.4102 9.37998 10.1402 9.09998 9.82016 9.09998Z"
					fill={color}
				/>
				<path
					d="M9.82016 12.39H8.50016C8.17016 12.39 7.91016 12.67 7.91016 13.01C7.91016 13.35 8.18016 13.63 8.50016 13.63H9.82016C10.1502 13.63 10.4102 13.35 10.4102 13.01C10.4102 12.67 10.1402 12.39 9.82016 12.39Z"
					fill={color}
				/>
				<path
					d="M9.81998 15.69H3.56998C3.23998 15.69 2.97998 15.97 2.97998 16.31C2.97998 16.65 3.24998 16.93 3.56998 16.93H9.81998C10.15 16.93 10.41 16.65 10.41 16.31C10.41 15.97 10.14 15.69 9.81998 15.69Z"
					fill={color}
				/>
				<path
					d="M3.98998 13.71H6.01998C6.56998 13.71 7.01998 13.25 7.02998 12.69V10.13C7.02998 9.56999 6.57998 9.10999 6.01998 9.10999H3.98998C3.43998 9.10999 2.98998 9.56999 2.97998 10.13V12.69C2.97998 13.25 3.42998 13.71 3.98998 13.71ZM3.98998 10.12H6.01998V12.68H3.98998V10.12Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_8450_11319">
					<rect width="22" height="22" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default memo(AppArticleCategoryIcon);
